import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { NavArrowRightIcon } from '@synoptic/ui-kit/icons/react/nav-arrow-right.js';
import { ViewColumns3Icon } from '@synoptic/ui-kit/icons/react/view-columns-3.js';
import clsx from 'clsx';
import { HTMLAttributes, useState } from 'react';
import { useMatch, useSearchParams } from 'react-router';
import { paths } from '@/routes-utils/paths.ts';
import { useAppLoader } from '@/routes/_app/loader.ts';
import {
  CollapsibleMenuAction,
  CollapsibleMenuTrigger,
} from '@/routes/_app/sidebar/menu/menu-action/collapsible-menu-action.tsx';
import { MenuActionLink } from '@/routes/_app/sidebar/menu/menu-action/menu-action-link.tsx';
import { MenuSubActionLink } from '@/routes/_app/sidebar/menu/menu-action/menu-sub-action-link.tsx';
import { useStreamDecks } from '@/routes/_app/use-stream-decks';
import {
  navArrowButton,
  navArrowDown,
  navArrowUp,
  streamDeckSubMenuLink,
} from './menu-action.css';

const DECKS_LIMIT_ON_INIT = 4;

export const StreamDeckSubMenu = (props: HTMLAttributes<HTMLElement>) => {
  const { authenticated } = useAppLoader();

  if (!authenticated) {
    return <StreamDeckMenuActionLink {...props} />;
  }

  return <AuthenticatedStreamDeckSubMenu {...props} />;
};

const StreamDeckMenuActionLink = (props: HTMLAttributes<HTMLElement>) => (
  <MenuActionLink
    icon={<ViewColumns3Icon />}
    to={paths.newsDeck}
    label={'NewsDeck'}
    {...props}
  />
);

const AuthenticatedStreamDeckSubMenu = (props: HTMLAttributes<HTMLElement>) => {
  const isActiveStreamDeckRoute = Boolean(useMatch(paths.newsDeck));

  const [searchParams] = useSearchParams();

  const streamDecks = useStreamDecks();

  const activeDeckId = searchParams.get('id') || streamDecks[0]?.id;

  const [isMoreDecksOpen, setIsMoreDecksOpen] = useState(false);

  const visibleDecks = isMoreDecksOpen
    ? streamDecks
    : streamDecks?.slice(0, DECKS_LIMIT_ON_INIT);

  if (!isActiveStreamDeckRoute || streamDecks?.length < 2) {
    return <StreamDeckMenuActionLink {...props} />;
  }

  return (
    <CollapsibleMenuAction
      defaultOpen={isActiveStreamDeckRoute}
      collapsedActionLink={<StreamDeckMenuActionLink {...props} />}
      trigger={
        <CollapsibleMenuTrigger
          active={isActiveStreamDeckRoute}
          icon={<ViewColumns3Icon />}
          label={'NewsDeck'}
        />
      }
    >
      {visibleDecks.map((deck) => (
        <MenuSubActionLink
          key={deck.id}
          to={`${paths.newsDeck}?id=${deck.id}`}
          label={deck.name}
          className={clsx({
            [streamDeckSubMenuLink]: activeDeckId !== deck.id,
          })}
        />
      ))}
      {streamDecks?.length > DECKS_LIMIT_ON_INIT && (
        <Button
          className={navArrowButton}
          onClick={() => setIsMoreDecksOpen(!isMoreDecksOpen)}
        >
          {isMoreDecksOpen ? 'less decks' : 'more decks'}
          <NavArrowRightIcon
            className={isMoreDecksOpen ? navArrowUp : navArrowDown}
          />
        </Button>
      )}
    </CollapsibleMenuAction>
  );
};
